/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { IconButton, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import {
  CSSObject,
  Theme,
  styled,
} from '@mui/material/styles';
import { twMerge } from 'tailwind-merge';
import * as React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  ApplicationSwitcher, OrganizationSwither,
  ProfileInfo, useAuth, hasModuleAccess,
} from '@panna/auth';
import { MenuItem } from 'src/components';
import {
  HamburgerIcon,
  LeftArrowIcon,
} from 'src/icons';
// import API from '../../network';
import { menu } from './menu';

const drawerWidth = 250;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  borderRight: 'unset',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  borderRight: 'unset',
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default function MainLayout() {
  const [open, setOpen] = React.useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const authContext = useAuth();

  const accountsUrl = process.env.REACT_APP_AUTH_DOMAIN;

  const { signOut } = authContext;
  // const authContext = useAuth();

  // const { authState: auth, signOut } = authContext;

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const onClickHandler = (href: string, url: string) => {
    if (href !== '') navigate(href);
    else if (url !== '') window.open(`${accountsUrl}${url}`, '_blank', 'noopener,noreferrer');
  };

  const filteredMenu = menu.filter((item) => {
    if (item.modules) {
      return hasModuleAccess(authContext?.authState?.userInfo?.modules || [], item.modules || []);
    }

    if (item.module) {
      return hasModuleAccess(authContext?.authState?.userInfo?.modules || [], item.module);
    }

    return true;
  });

  const handleLogout = async () => {
    console.info('handleLogout');
    await signOut();
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
      >
        <div className={twMerge('flex bg-[#ffcccc] justify-between items-center p-2 gap-2', !open && 'flex-col-reverse')}>
          <OrganizationSwither iconClassName="!fill-primary stroke-primary" reloadOnOrganizationSwitch iconOnly={!open} />
          <ApplicationSwitcher iconClassName="fill-primary" />
        </div>
        <div className="mb-2" />
        <Stack
          direction="column"
          justifyContent="space-between"
          alignItems="stretch"
          spacing={10}
          className="h-screen"
        >
          <Stack
            direction="column"
            justifyContent="space-between"
            alignItems="stretch"
            spacing={5}
          >
            <ProfileInfo open={open} />
            <List className="mt-10">
              {
                filteredMenu.map(
                  (item) => {
                    const selected = location.pathname.startsWith(item.href as string);
                    return (
                      <MenuItem
                        selected={selected}
                        key={item.name}
                        onClick={onClickHandler}
                        expanded={open}
                        href={item.href}
                        url={item.url}
                        name={item.name}
                        Icon={item.Icon}
                        childrenList={item.childrenList}
                      />
                    );
                  },
                )
              }
            </List>
          </Stack>
          <MenuItem
            key="logout"
            expanded={open}
            name="Logout"
            Icon={LeftArrowIcon}
            onClick={handleLogout}
          />
        </Stack>
      </Drawer>
      <div className="w-full relative min-h-screen transition-all bg-[#fafafa]">
        <IconButton
          size="small"
          onClick={!open ? handleDrawerOpen : handleDrawerClose}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 10,
          }}
        >
          {/* {!open ? <BsArrowRight /> : <BsArrowLeft />} */}
          <HamburgerIcon />
        </IconButton>
        <Outlet />
      </div>
    </Box>
  );
}
